import { FormSection } from '../../components/ui/FormSection';
import { VenueMediaManager } from '../../components/MediaLibrary/VenueMediaManager';

interface MediaManagementTabProps {
  venueId: string;
  logoImageId: string | undefined;
  heroImageIds: string[];
  galleryImageIds: string[];
  onLogoChange: (logoId: string | null) => void;
  onHeroImagesChange: (heroIds: string[]) => void;
  onGalleryImagesChange: (galleryIds: string[]) => void;
}

export const MediaManagementTab = ({
  venueId,
  logoImageId,
  heroImageIds,
  galleryImageIds,
  onLogoChange,
  onHeroImagesChange,
  onGalleryImagesChange,
}: MediaManagementTabProps) => (
  <div>
    <FormSection
      title="Media Management"
      description="Manage your venue's logo, hero images, and gallery images. Changes are saved when you submit the form."
    >
      <VenueMediaManager
        venueId={venueId}
        logoImageId={logoImageId}
        heroImageIds={heroImageIds}
        galleryImageIds={galleryImageIds}
        onLogoChange={onLogoChange}
        onHeroImagesChange={onHeroImagesChange}
        onGalleryImagesChange={onGalleryImagesChange}
      />
    </FormSection>
  </div>
);
